module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-bottom-sheet', {
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('v-list', {
    staticClass: "pa-0 grey grey lighten-2",
    attrs: {
      "three-line": _vm.$vuetify.breakpoint.xs
    }
  }, [_c('v-list-tile', [(_vm.appointment && _vm.appointment.is_online) ? _c('v-list-tile-avatar', [_c('v-icon', [_vm._v("headset_mic")])], 1) : _vm._e(), _vm._v(" "), (_vm.withPreview) ? _c('v-list-tile-action', [(_vm.screen === _vm.screens.ACTIONS) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.screen = _vm.screens.PREVIEW
      }
    }
  }, [_c('v-icon', [_vm._v("visibility")])], 1) : _vm._e(), _vm._v(" "), (_vm.screen === _vm.screens.PREVIEW) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.screen = _vm.screens.ACTIONS
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_backspace")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.appointmentId) ? _c('v-list-tile-action', {
    staticStyle: {
      "min-width": "30px"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.sharedialog = true
      }
    }
  }, [_c('v-icon', [_vm._v("ios_share")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n            " + _vm._s(_vm.title) + "\n            "), (_vm.formattedStatus && _vm.formattedStatus.title) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    class: _vm.formattedStatus.theme,
    attrs: {
      "label": "",
      "dark": ""
    }
  }, [_vm._v("\n              " + _vm._s(_vm.formattedStatus.title) + "\n            ")]) : _vm._e()], 1), _vm._v(" "), (_vm.appointment.product) ? _c('v-list-tile-sub-title', [_vm._v("\n            " + _vm._s(_vm.product.title) + "\n            "), (_vm.appointment.practitioner_name) ? _c('span', [_vm._v("with " + _vm._s(_vm.appointment.practitioner_name))]) : _vm._e(), _vm._v(" "), (_vm.appointment.service_name) ? _c('span', [_vm._v("@ " + _vm._s(_vm.appointment.service_name))]) : _vm._e(), _vm._v(" "), (_vm.appointment.address_name) ? _c('v-chip', {
    staticClass: "v-chip--x-small hidden-xs-only"
  }, [_vm._v("\n              " + _vm._s(_vm.appointment.address_name) + "\n            ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.xs) ? _c('v-list-tile-sub-title', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("location_on")]), _vm._v("\n            " + _vm._s(_vm.appointment.address_name) + ".\n            "), _c('v-spacer'), _vm._v(" "), _c('strong', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.formatCurrency(_vm.appointment.currency, _vm.appointment.price)))])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.appointment && _vm.appointment.price) ? _c('v-list-tile-action', {
    staticClass: "hidden-xs-only"
  }, [_c('v-chip', {
    on: {
      "click": function($event) {
        return _vm.openGlobalDialog(true, 'InvoiceDetails', {
          appointment: _vm.appointment
        })
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.formatCurrency(_vm.appointment.currency, _vm.appointment.price)))])], 1) : _vm._e(), _vm._v(" "), (_vm.appointmentDetail && _vm.appointmentDetail.zoom_start_url) ? _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "href": _vm.appointmentDetail.zoom_start_url,
      "target": "_blank",
      "flat": "",
      "text": "",
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v("\n            Start meeting\n            "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.visible = false;
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('action-list', {
    attrs: {
      "appointment": _vm.appointment
    },
    on: {
      "actionselected": function($event) {
        _vm.visible = false
      }
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.appointment) ? _c('v-footer', {
    staticClass: "py-0 caption px-2",
    attrs: {
      "dark": ""
    }
  }, [(_vm.appointment.tags) ? [_vm._v("\n          Tags:\n          "), _vm._l((_vm.appointment.tags), function(tag) {
    return _c('v-chip', {
      key: tag,
      staticClass: "v-chip--x-small",
      attrs: {
        "outline": ""
      }
    }, [_vm._v(_vm._s(tag))])
  })] : _vm._e(), _vm._v("\n        Created " + _vm._s(_vm.dateformat(_vm.appointment.created_date)) + ".\n        "), _c('v-spacer'), _vm._v(" "), _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": "",
      "label": ""
    }
  }, [_vm._v("#" + _vm._s(_vm.appointment.id))])], 2) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "460",
      "fullscreen": _vm.$vuetify.breakpoint.xs
    },
    model: {
      value: (_vm.sharedialog),
      callback: function($$v) {
        _vm.sharedialog = $$v
      },
      expression: "sharedialog"
    }
  }, [(_vm.sharedialog) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "overline py-1 grey lighten-4"
  }, [_vm._v("\n          Share appointment\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.sharedialog = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.appointmentId) ? _c('share-appointment', {
    attrs: {
      "appointment-id": _vm.appointmentId
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-501e43d4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointment/actions/AppointmentBottomSheet.vue
// module id = 1422
// module chunks = 9